export default __webpack_public_path__ + "static/media/teleconsult-dependent-placeholder.45532e69.svg";